import { AccountTriageState as _accountTriageState } from '@interfaces/state';
import { Action, createReducer, on } from '@ngrx/store';
import {
  AccountTypes,
  IndividualDesignationListedTypes,
  IRADesignationListedTypes,
  YesNoEmpty,
} from '@shared/models';
import * as AdaptedStateActions from '@store/actions/adapted-state/adapted-state.actions';

import { ClearAccountTriageState, UpdateAccountTriageSelections } from '../../actions';

export interface AccountTriageState extends _accountTriageState {}

export const initialState: AccountTriageState = {
  accountTypeInheriting: AccountTypes.EMPTY,
  isSpouse: '',
  IRADesignation: IRADesignationListedTypes.EMPTY,
  individualDesignation: IndividualDesignationListedTypes.EMPTY,
  isOnlyBeneficiary: YesNoEmpty.EMPTY,
  isNotOnlyInheritingAccount: false,
  isOnlyChild: false,
};

const accountTriageReducer = createReducer(
  initialState,
  on(UpdateAccountTriageSelections, (state, { payload }) => ({
    ...state,
    ...payload,
  })),
  on(ClearAccountTriageState, () => {
    return initialState;
  }),
  on(AdaptedStateActions.ClearCurrentTransactionState, () => {
    return initialState;
  }),
  on(AdaptedStateActions.SetTransactionAsCurrent, (state, { transaction }) => {
    return {
      ...state,
      ...transaction.accountTriage,
    };
  }),
);

export function reducer(state: AccountTriageState | undefined, action: Action) {
  return accountTriageReducer(state, action);
}

export const getAccountTypeInheriting = (state: AccountTriageState) => state.accountTypeInheriting;
